export default __webpack_public_path__ + "assets/mobile-homebanner.193a77f1.jpg";